import { categories, movies, type Movie } from "@/mocks/movies";

export function resolveCategory(type?: string) {
  if (!type) return undefined;
  const decoded = decodeURIComponent(type);
  return categories.find((c) => c.key === decoded || c.label === decoded);
}

export function matchCategory(movie: Movie, key?: string): boolean {
  switch (key) {
    case "film":
      return movie.typeLabel === "电影";
    case "tv":
      return movie.typeLabel === "电视剧";
    case "guochan":
      return movie.typeLabel === "电视剧" && movie.region === "中国大陆";
    case "oumei":
      return movie.typeLabel === "电视剧" && (movie.region === "美国" || movie.region === "英国");
    case "hanju":
      return movie.typeLabel === "电视剧" && movie.region === "韩国";
    case "riju":
      return movie.typeLabel === "电视剧" && movie.region === "日本";
    case "dongman":
      return movie.tags.includes("动漫");
    default:
      return true;
  }
}

export interface FilterOptions {
  category?: string;
  genre?: string;
  region?: string;
  year?: string;
  sort?: string;
}

export function filterMovies(options: FilterOptions): Movie[] {
  const { category, genre, region, year, sort } = options;
  let list = movies.filter((m) => matchCategory(m, category));

  if (genre) list = list.filter((m) => m.genres.includes(genre));
  if (region) list = list.filter((m) => m.region === region);
  if (year) list = list.filter((m) => String(m.year) === year);

  switch (sort) {
    case "time":
      list = [...list].sort((a, b) => b.year - a.year || b.rating - a.rating);
      break;
    case "rating":
      list = [...list].sort((a, b) => b.rating - a.rating);
      break;
    default:
      list = [...list].sort((a, b) => b.views - a.views);
  }
  return list;
}

export function searchMovies(keyword: string): Movie[] {
  const kw = keyword.trim().toLowerCase();
  if (!kw) return [];
  return movies.filter((m) => {
    return (
      m.title.toLowerCase().includes(kw) ||
      m.director.toLowerCase().includes(kw) ||
      m.synopsis.toLowerCase().includes(kw) ||
      m.region.toLowerCase().includes(kw) ||
      m.genres.some((g) => g.toLowerCase().includes(kw)) ||
      m.actors.some((a) => a.toLowerCase().includes(kw))
    );
  });
}

export function getMovieById(id?: string): Movie | undefined {
  if (!id) return undefined;
  return movies.find((m) => m.id === id);
}

export function getRelatedMovies(movie: Movie, limit = 6): Movie[] {
  return movies
    .filter((m) => m.id !== movie.id)
    .map((m) => {
      const genreScore = m.genres.filter((g) => movie.genres.includes(g)).length;
      const score = genreScore * 2 + (m.region === movie.region ? 1 : 0) + m.rating / 10;
      return { m, score };
    })
    .sort((a, b) => b.score - a.score)
    .slice(0, limit)
    .map((item) => item.m);
}